import { apiCall } from "@/api/client";
import type { BuildChannel, ListBuildsResponse } from "@/types/api";

/**
 * List dataplane builds from the CATALOG#builds catalogue, newest-first.
 * Optionally filter by channel (``production`` / ``beta``). Backed by the
 * JWT-authorized GET /catalog/builds route on the catalog_admin Lambda.
 */
export function listBuilds(token: string, channel?: BuildChannel) {
  const qs = channel ? `?channel=${encodeURIComponent(channel)}` : "";
  return apiCall<ListBuildsResponse>(`/catalog/builds${qs}`, { token });
}
